import { ChangeEvent, FormEvent, ReactElement, useEffect, useState } from "react";
import { IButtonGroup, IColumn, IPaginacionComponent } from "../../Interfaces/filter";
import { DefaultButton, DetailsList, DetailsListLayoutMode, Selection, IComboBox, IComboBoxOption, IDropdownOption, IObjectWithKey, SelectionMode, CheckboxVisibility, FontIcon, NeutralColors } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { ButtonsGroupTabla } from "../button/ButtonsGroupTabla";
import { SpinnerTable } from "../spinner/spinnerTable";
import { PaginationComponent } from "../Pagination/PaginationComponent";
import { mergeStyles, mergeStyleSets } from '@fluentui/react/lib/Styling';

interface ITableComponent {
  isSearch?: boolean;
  column?: IColumn[] | any;
  data: any[];
  hiddenBorder?: boolean;
  height?: string;
  placeholderSearch?: string;
  isLoading?: boolean;
  searchValue?: string;
  comboOptions?: IComboBoxOption[];
  onSelectCombo?: (event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => void;
  leftButtons?: IButtonGroup[];
  defaultSelectedOptions?: IComboBoxOption[];
  rightButton?: IButtonGroup[];
  rightText?: string | ReactElement;
  onChangeSearch?: (
    event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string
  ) => void;
  paginacion?: IPaginacionComponent;
  customTableWidth?: boolean;
  onEnterTextBox?: () => void;
  labelString?: string,
  btnString?: string
  navigate?: string
  setOpen?: (boolean) => void
  header?: boolean,
  compact?: boolean
  tableWidth?: string
  selection?: SelectionMode
  isSelectionEnabled?: boolean
  preSelectedItemIds?: string[],
  onSelectionChange?: any
  setItemSeleccionadoValue?: React.Dispatch<any>
  visualizar?: () => JSX.Element
}
const iconClass = mergeStyles({
  fontSize: 40,
  height: 50,
  width: 50,
  padding: '25px 0 0 0',
});

const classNames = mergeStyleSets({
  contentIcon: [{ color: NeutralColors.gray70 }, iconClass],
});
export const TableComponent = (props: ITableComponent) => {
  const navigate = useNavigate();
  const tableData = Array.isArray(props.data) ? props.data : [];

  const selection = new Selection({
    onSelectionChanged: () => {
      const selectedItems = selection.getSelection();
      props.onSelectionChange?.(selectedItems);
    },
  });
  useEffect(() => {
    if (props.isSelectionEnabled && props.preSelectedItemIds && props.preSelectedItemIds.length > 0) {
      const itemIndexes = tableData.reduce((indexes, item, index) => {
        if (props.preSelectedItemIds && props.preSelectedItemIds.includes(item.id)) {
          indexes.push(index);
        }
        return indexes;
      }, []);

      selection.setIndexSelected(itemIndexes, true, true);
    }
  }, [props.preSelectedItemIds, tableData, props.isSelectionEnabled]);
  const renderEmptyState = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "gray",
        textAlign: "center",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
        <FontIcon aria-label="Refresh" iconName="Refresh" className={classNames.contentIcon} />
        <h4 style={{ margin: "0" }}>No se encontraron registros</h4>
      </div>
      {props.btnString && (
        <>
          <div>¿Desea añadir {props.labelString}?</div>
          <br />
          <DefaultButton
            text={props.btnString}
            onClick={() => {
              if (props.setOpen) {
                props.setOpen(true);
              } else if (props.navigate) {
                navigate(props.navigate);
              }
            }}
            style={{ marginTop: "10px" }}
          />
        </>
      )}
    </div>
  )
  return (
    <div
      style={{ width: "100%", height: '10px', scrollbarWidth: "none", }}
    >
      <div>
        <ButtonsGroupTabla
          isSearch={props.isSearch}
          leftButtons={props.leftButtons}
          value={props.searchValue}
          defaultSelectedOptions={props.defaultSelectedOptions}
          comboOptions={props.comboOptions}
          rightText={props.rightText}
          onSelectCombo={props.onSelectCombo}
          rightButton={props.rightButton}
          placeholder={props.placeholderSearch}
          onChangeSearch={props.onChangeSearch}
          onEnterTextBox={props.onEnterTextBox}
        />
      </div>
      <div
        style={{
          flex: 1,
          transition: "width 0.5s ease",
          //display: "flex",
          minWidth: "1fr",
          overflowX: "scroll",
          margin: "0px 0px",
          paddingBottom: "20px",
          minHeight: "30px",
          maxHeight: "500px",
          overflowY: "scroll",
          borderTop: "1px solid #0078d3",
          scrollbarWidth: "none",
          borderBottom: props.hiddenBorder ? "0px" : "0.5px solid #b3b3b3",
          boxShadow: props.hiddenBorder
            ? "none"
            : "0px 1px 0px rgba(0, 0, 0, 0.1)",
        }}
      >
        {!props.isLoading ? (
          tableData.length === 0 ? (
            renderEmptyState()
          ) : (
            <div style={{ display: 'flex' }}>
              <div style={{ width: props.tableWidth != null ? props.tableWidth : "100%" }}>
                <DetailsList
                  items={tableData}
                  isHeaderVisible={props.header == null ? true : props.header}
                  compact={props.compact == null ? false : props.compact}
                  columns={props.column}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selection={props.isSelectionEnabled ? selection : undefined}
                  selectionMode={props.isSelectionEnabled ? SelectionMode.multiple : SelectionMode.none}
                  selectionPreservedOnEmptyClick={props.isSelectionEnabled}
                  onShouldVirtualize={() => true}
                  //checkboxVisibility={CheckboxVisibility.hidden}
                  styles={{
                    root: { overflowY: "auto" },
                  }}
                />
              </div>
              {props.visualizar && (<div>
                {props.visualizar()}
              </div>)}
            </div>
          )
        ) : (
          <SpinnerTable />
        )}
      </div>
      {props.paginacion?.isVisible && (
        <div style={{ paddingTop: '5px' }}>
          <PaginationComponent
            actualPage={props.paginacion.actualPage ?? 0}
            onChangeTake={props.paginacion.onChangeTake}
            onChangeSkip={props.paginacion.onChangeSkip}
            totalPagesPagination={props.paginacion.totalPagesPagination}
            skipPagination={props.paginacion.skipPagination}
            takePagination={props.paginacion.takePagination}
            isLoading={props.isLoading}
            cantidad={tableData.length}
            total={props.paginacion.total} isVisible={true} />
        </div>
      )}
    </div>

  )
}
